import type { BookableClassFragment } from '@lingoda/monolith-graphql';

type ClassKeySource = Pick<BookableClassFragment, 'isExisting' | 'startDate' | 'uid'> & {
    readonly lesson: { readonly id: number } | null;
};

// Existing classes have stable uids, generated ones get a fresh uid per request,
// so those are identified by startDate + lesson (mirrors the `classes` cache field policy).
const getClassKey = (bookableClass: ClassKeySource) => {
    return bookableClass.isExisting
        ? bookableClass.uid
        : `${bookableClass.startDate}-${bookableClass.lesson?.id ?? 0}`;
};

export const excludeDisplayedClasses = <T extends ClassKeySource>(
    suggestedClasses: ReadonlyArray<T>,
    displayedClasses: ReadonlyArray<ClassKeySource>,
) => {
    const displayedKeys = new Set(displayedClasses.map(getClassKey));

    return suggestedClasses.filter((suggested) => !displayedKeys.has(getClassKey(suggested)));
};
